import { render, staticRenderFns } from "./machineInfo.vue?vue&type=template&id=0cb2d880"
import script from "./machineInfo.vue?vue&type=script&lang=js"
export * from "./machineInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports